import React from 'react';

import { Image } from '@chakra-ui/react';
import { MdSupportAgent } from 'react-icons/md';

import { Button, ButtonProps } from '@/components/core';
import { Agent } from '@/types/agents';

interface AgentButtonProps extends ButtonProps {
  agent?: Agent;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  loadingText?: string;
  iconOnly?: boolean;
}

export const AgentButton: React.FC<AgentButtonProps> = ({
  agent,
  onClick,
  isLoading,
  loadingText,
  iconOnly = false,
  minW,
  ...props
}) => {
  const label = `Ask ${agent?.name ?? 'AI'}`;
  const avatar = (
    <Image
      src={agent?.avatar?.url}
      alt={`${(agent?.name ?? 'AI').toLowerCase()}-avatar`}
      boxSize={iconOnly ? 8 : 4}
      minW={iconOnly ? 8 : 4}
      h={iconOnly ? 8 : 4}
      borderRadius='full'
      objectFit='cover'
      fallback={<MdSupportAgent size={iconOnly ? 18 : 16} />}
    />
  );

  return (
    <Button
      size='sm'
      colorScheme='white'
      variant='outline'
      bg='buttons.social-auth.bg'
      borderColor='buttons.social-auth.border'
      color='buttons.social-auth.font'
      aria-label={label}
      _hover={{
        bg: 'glass-items.bg-double-hover',
        borderColor: 'glass-items.border-double-hover',
      }}
      _active={{
        bg: 'glass-items.bg-double-hover',
        borderColor: 'glass-items.border-double-hover',
      }}
      onClick={onClick}
      isLoading={isLoading}
      {...props}
      {...(iconOnly
        ? {
            py: 0,
            pl: 0,
            pr: 0,
            p: 0,
            minW: 8,
            w: 8,
            h: 8,
            borderRadius: 'full' as const,
            overflow: 'hidden',
            leftIcon: undefined,
            loadingText: undefined,
          }
        : {
            py: 2,
            pl: 2,
            pr: 2.5,
            minW,
            leftIcon: avatar,
            loadingText: loadingText || label,
          })}
    >
      {iconOnly ? avatar : label}
    </Button>
  );
};
